import { usePageProps } from '@redbubble/next-provider';
import { RbExperiments } from './experiments';
export var useExperiments = function () {
    var experiments = usePageProps().experiments;
    return new RbExperiments(experiments);
};
